import React from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';
import type { Bygg } from '@forvalter/types/ForvalterCommonDAL';
import { useGetByggListQuery } from '@klp/contextSelector/services/rtkApi';

interface ByggSelectProps {
    selectedBuilding: Array<Bygg>;
    onChange: (value: Array<Bygg>) => void;
    required?: boolean;
}

export const ByggSelect: React.FC<ByggSelectProps> = ({
    selectedBuilding,
    onChange,
    required = false,
}) => {
    const { t } = useTranslation();
    const { data: byggList = [] } = useGetByggListQuery({ includeAll: true });
    return (
        <Autocomplete<Bygg, true>
            multiple={true}
            options={byggList}
            value={selectedBuilding}
            getOptionLabel={(option) => `${option.navn} (${option.nummer})`}
            getOptionSelected={(option, selectedValue) =>
                option.nummer === selectedValue?.nummer
            }
            onChange={(_event, newValue) => {
                onChange(newValue ?? null);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={t('reportMapping.mappingAdd.selectBuilding')}
                    placeholder={t('reportMapping.mappingAdd.searchBuildings')}
                    variant="outlined"
                    fullWidth={true}
                    required={required}
                    InputProps={{
                        ...params.InputProps,
                    }}
                />
            )}
        />
    );
};
